/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_ApproveInputs */

const en_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve »`)
};

const de_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen »`)
};

const es_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar »`)
};

const fr_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver »`)
};

const nl_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goedkeuren »`)
};

const pt_br2_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar »`)
};

const ro_admin_dashboard_approve = /** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobati »`)
};

/** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */
const it_admin_dashboard_approve = en_admin_dashboard_approve;

/** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */
const pl_admin_dashboard_approve = en_admin_dashboard_approve;

/** @type {(inputs: Admin_Dashboard_ApproveInputs) => LocalizedString} */
const hu_admin_dashboard_approve = en_admin_dashboard_approve;

/**
* | output |
* | --- |
* | "Approve »" |
*
* @param {Admin_Dashboard_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_approve = /** @type {((inputs?: Admin_Dashboard_ApproveInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_ApproveInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_approve(inputs)
	if (locale === "de") return de_admin_dashboard_approve(inputs)
	if (locale === "es") return es_admin_dashboard_approve(inputs)
	if (locale === "fr") return fr_admin_dashboard_approve(inputs)
	if (locale === "nl") return nl_admin_dashboard_approve(inputs)
	if (locale === "it") return it_admin_dashboard_approve(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_approve(inputs)
	if (locale === "pl") return pl_admin_dashboard_approve(inputs)
	if (locale === "hu") return hu_admin_dashboard_approve(inputs)
	return ro_admin_dashboard_approve(inputs)
});
export { admin_dashboard_approve as "admin.dashboard.approve" }